import { stringify } from 'qs';
import request from './utils/request';

// 获取首页信息
export async function getIndex(params) {
  return request(`/wechat/index?${stringify({ aid: localStorage.getItem('aid'), ...params })}`);
}

// 获取配置信息
export async function getSetting(params) {
  return request(`/wechat/setting/view?${stringify({ aid: localStorage.getItem('aid'), ...params })}`);
}

// 获取手机验证码
export async function getCaptcha(params) {
  return request('/wechat/sms/send', {
    method: 'post',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ aid: localStorage.getItem('aid'), ...params }),
  });
}

// 验证短信验证码
export async function validateCaptcha(params) {
  return request('/wechat/sms/validate', {
    method: 'post',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(params),
  });
}

// 获取 Eyecheck 列表
export async function getEyecheck(params, handleDefaultError) {
  return request(`/wechat/eyecheck/cx?${stringify({
    aid: localStorage.getItem('aid'),
    ...params,
  })}`, undefined, handleDefaultError);
}

// 获取 Eyecheck 列表
export async function queryResult(params) {
  return request(`/wechat/result/query-result?${stringify({
    aid: localStorage.getItem('aid'),
    ...params,
  })}`);
}

// 获取 Eyecheck 列表 by mobile
export async function queryResultByMobile(params) {
  return request(`/wechat/result/query-result-by-mobile?${stringify({
    aid: localStorage.getItem('aid'),
    ...params,
  })}`);
}

// 获取 Eyecheck 列表 by name
export async function queryResultByName(params) {
  return request(`/wechat/result/query-result-by-name?${stringify({
    aid: localStorage.getItem('aid'),
    ...params,
  })}`);
}

// 获取 Eyecheck 列表 by idcard
export async function queryResultByIdcard(params) {
  return request(`/wechat/result/query-result-by-idcard?${stringify({
    aid: localStorage.getItem('aid'),
    ...params,
  })}`);
}

// 获取 Eyecheck 列表 by birthday
export async function queryResultByBirthday(params) {
  return request(`/wechat/result/query-result-by-name-and-birthday?${stringify({
    aid: localStorage.getItem('aid'),
    ...params,
  })}`);
}

// 地区列表
export async function getAreaList(params) {
  return request(`/wechat/result/area-list?${stringify(params)}`);
}

// 学校列表
export async function getSchoolList(params) {
  return request(`/wechat/result/school-list?${stringify({ aid: localStorage.getItem('aid'), ...params })}`);
}
// 年级列表
export async function getGradeList(params) {
  return request(`/wechat/result/grade-list?${stringify({ aid: localStorage.getItem('aid'), ...params })}`);
}
// 班级列表
export async function getClassList(params) {
  return request(`/wechat/result/class-list?${stringify({ aid: localStorage.getItem('aid'), ...params })}`);
}

// 社区列表
export async function getCommunityList(params) {
  return request(`/wechat/result/community-list?${stringify({ aid: localStorage.getItem('aid'), ...params })}`);
}

// 根据 id 获取 Eyecheck 信息 TODO: 安全风险
export async function getEyecheckDetail(id) {
  return request(`/wechat/eyecheck/${id}`);
}

// 获取报告
export async function report(params) {
  return request(`/app/report/list?${stringify({ aid: localStorage.getItem('aid'), ...params })}`);
}

// 更新 eyecheck
export async function updateEyecheck(params) {
  return request('/wechat/eyecheck-evaluation/update-eyecheck', {
    method: 'post',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(params),
  });
}

// 回答问题
export async function answerEyecheck(params) {
  return request('/wechat/eyecheck-evaluation/answer', {
    method: 'post',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(params),
  });
}

// 自测
export async function testEyecheck(params) {
  return request('/wechat/eyecheck-evaluation/self-test', {
    method: 'post',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(params),
  });
}
